import {Button, Modal, Table} from "antd";
import React from "react";
import {useTranslation} from "react-i18next";

const ResourcesTable = (props) => {
    const {resInfo, setResInfo} = props
    const {t} = useTranslation(['common', 'action'])

    const columns = [
        {
            title: 'Код ресурса',
            //dataIndex: 'code',
            key: 'code',
            width: '15%',
            render: (data) =>  data.codeKKM ? data.codeKKM : data.code
        },
        /*{
            title: 'Код по каталогу-классификатору',
            dataIndex: 'codeKKM',
            key: 'codeKKM',
        },*/
        {
            title: 'Наименование ресурса',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Единица измерения',
            dataIndex: 'unitName',
            key: 'unitName',
        },
        {
            title: 'Расход',
            dataIndex: 'value',
            key: 'value',
        },
    ];

    function handleCancel() {
        setResInfo({visible: false, data: null})
    }

    return (
        <div className='object-analog-table-div'>
            <Modal
                title={resInfo.data.name}
                open={resInfo.visible}
                destroyOnHidden
                onCancel={handleCancel}
                width={1200}
                footer={[
                    <Button
                        key="save"
                        onClick={handleCancel}
                    >
                        Ok
                    </Button>
                ]}
            >
                    <Table
                        //loading={loading}
                        columns={columns}
                        dataSource={resInfo.data?.resources.map((el, idx) => ({key: idx, ...el}))}
                        //pagination={{ pageSize: 10 }}
                        size="middle"
                    />
            </Modal>
        </div>
    )
}

export default ResourcesTable
